@switch (status()) {
  @case (ActionStatus.SUCCESS) {
    <tui-icon class="text-foreground-tertiary" icon="@tui.cloud-check" [style.fontSize]="iconFontSize()" />
  }
  @case (ActionStatus.ERROR) {
    <tui-icon class="text-status-negative" icon="@tui.cloud-alert" [style.fontSize]="iconFontSize()" />
  }
  @case (ActionStatus.INTERRUPTION) {
    <tui-icon class="text-text-warning-primary" icon="@tui.cloud-alert" [style.fontSize]="iconFontSize()" />
  }
  @case (ActionStatus.WAITING) {
    <!-- Same chip as an upload under way, minus the number: 0% would read as a stalled upload. -->
    <pxc-sync-progress-chip [variant]="variant() === 'iconOnly' ? 'flat' : 'detailed'" />
  }
  @default {
    <pxc-sync-progress-chip [percentage]="percentage()" [variant]="variant() === 'iconOnly' ? 'flat' : 'detailed'" />
  }
}
